import Datetime from './datetime.vue';

export default Datetime;


// WEBPACK FOOTER //
// ./src/components/inputs/datetime/index.js